$(document).ready(function() {
  $(".sliderule__wrapper.expands").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).find( ".sliderule__panel" ).slideUp(500);
    } else {
      $(this).addClass("active");
      $(".sliderule__panel").slideUp(500);
      $(this).find( ".sliderule__panel" ).slideDown(500);
      return false;
    }
  });
  if ($(window).width() > 575) {
    const slider = document.querySelector('.collection-sub-nav ul');
    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.classList.add('active');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });
    slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.classList.remove('active');
    });
    slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.classList.remove('active');
    });
    slider.addEventListener('mousemove', (e) => {
      if(!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 3; //scroll-fast
      slider.scrollLeft = scrollLeft - walk;
      console.log(walk);
    });
  }
});
